import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';


const columns = [
    {
        dataField: 'id',
        text: 'Sr.No',
        formatter: (cell, row, rowIndex) => {
            return rowIndex + 1
        }
    },
    {
        dataField: 'countryName',
        text: 'Country Name'
    },
    {
        dataField: '',
        text: 'Action',
        formatter: (cell, row, rowIndex) => {
            return <div className='edit-color'>
                <Link to={`/update/country/form/${row.id}`}>Edit</Link>
            </div>
        }
    }
];


export default columns;
